import { InjectionToken } from '@angular/core';
import { CommonsSessionStorageService, upgradeAJSServiceProvider } from 'ib-web-commons/utils'; 
export const AJSGiftCardsCommonsSessionStorageService = new InjectionToken('CommonsSessionStorageService');
export const AJSGiftCardsCommonsSessionStorageServiceProvider = upgradeAJSServiceProvider('CommonsSessionStorageService', AJSGiftCardsCommonsSessionStorageService);
export interface GiftCardsCommonsSessionStorageServiceType extends CommonsSessionStorageService {
    remove(key, config?)
    clearAll(pattern?, config?)
    set(key, value, config?)
    get(key, config?)
}
